import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { getEmployeeById } from '../../../../../reducers';
import UserCard from 'components/users/UserCard';
import { ResourceCardElement } from 'components/ResourceCardElements';

const InstallerCard = ({ installer, user, employee = {} }) => (<UserCard
  user={installer}
  role={user.role}
  workrooms={employee.workrooms || []}
  type="installers"
>
  <ResourceCardElement
    title="Workroom"
    size="small"
    value={(installer.workrooms || []).length > 0 ? installer.workrooms : 'No Workroom'}
  />
  <ResourceCardElement title="Surface Types" size="small" value={installer.surface_types} />
</UserCard>);

InstallerCard.propTypes = {
  installer: PropTypes.object,
  user: PropTypes.object,
  employee: PropTypes.object,
};

export default connect((state, ownProps) => ({
  employee: getEmployeeById(state)[ownProps.user.employable_id],
}))(InstallerCard);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/installers/components/installerCard.jsx